import { useEffect, useState } from "react";
import { Check, X, DollarSign } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminAffiliates() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/affiliates").then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (a, patch) => { try { await api.put(`/admin/affiliates/${a.id}`, patch); load(); toast.success("Updated."); } catch (e) { toast.error(apiErr(e)); } };
  const payout = async (a) => { if (!window.confirm(`Log payout of $${a.unpaid_earnings?.toFixed(2)} to ${a.name}?`)) return; try { const { data } = await api.post(`/admin/affiliates/${a.id}/payout`); toast.success(`Paid $${data.paid.toFixed(2)}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div data-testid="admin-affiliates">
      <h1 className="font-heading text-4xl tracking-tight mb-2">Affiliates & Ambassadors</h1>
      <p className="font-body text-sm text-ink/60 mb-8">Approve creators, set commission rates and log payouts.</p>

      <div className="adm-card p-0 overflow-hidden">
        <table className="w-full text-left font-body text-sm">
          <thead className="bg-cream"><tr className="uppercase tracking-wide2 text-[0.6rem] text-ink/60">
            <th className="px-5 py-3">Creator</th><th className="px-5 py-3">Code</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Rate</th>
            <th className="px-5 py-3">Clicks</th><th className="px-5 py-3">Conv.</th><th className="px-5 py-3">Unpaid</th><th className="px-5 py-3"></th></tr></thead>
          <tbody>
            {list.map((a) => (
              <tr key={a.id} className="border-t border-ink/5" data-testid={`affiliate-row-${a.code}`}>
                <td className="px-5 py-3"><p className="font-medium">{a.name}</p><p className="text-ink/50 text-xs">{a.social}</p></td>
                <td className="px-5 py-3 font-medium">{a.code}</td>
                <td className="px-5 py-3"><span className={`px-2 py-1 text-[0.6rem] uppercase tracking-wide2 ${a.status === "approved" ? "bg-green-900/10 text-green-900" : a.status === "rejected" ? "bg-destructive/10 text-destructive" : "bg-warm/40"}`}>{a.status}</span></td>
                <td className="px-5 py-3">
                  <input className="w-16 border border-ink/15 px-2 py-1 text-sm" type="number" defaultValue={a.commission_rate}
                         onBlur={(e) => e.target.value != a.commission_rate && update(a, { commission_rate: parseFloat(e.target.value) })} data-testid={`rate-${a.code}`} />%
                </td>
                <td className="px-5 py-3">{a.clicks}</td>
                <td className="px-5 py-3">{a.conversions}</td>
                <td className="px-5 py-3 font-medium">${(a.unpaid_earnings || 0).toFixed(2)}</td>
                <td className="px-5 py-3">
                  <div className="flex gap-2 justify-end">
                    {a.status !== "approved" && <button onClick={() => update(a, { status: "approved" })} className="icon-thin text-green-800" title="Approve" data-testid={`approve-${a.code}`}><Check size={16} /></button>}
                    {a.status !== "rejected" && <button onClick={() => update(a, { status: "rejected" })} className="icon-thin text-destructive" title="Reject"><X size={16} /></button>}
                    <button onClick={() => payout(a)} className="icon-thin text-ink/60 hover:text-ink" title="Log payout" data-testid={`payout-${a.code}`}><DollarSign size={16} /></button>
                  </div>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={8} className="px-5 py-10 text-center text-ink/40">No affiliates yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
